import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../providers/ThemeProvider";
import BeartrackLogo from "../../assets/beartrack/beartrack_logo.png";

// Captura del panel de Pedidos por idioma (claro/oscuro). La UI del producto va
// traducida, así que el preview del login debe mostrar la misma captura en el
// idioma activo. Se regeneran con /tmp/shotter/gen-login-previews.js.
import PedidosEs from "../../assets/beartrack/pedidos-preview-es.png";
import PedidosEsDark from "../../assets/beartrack/pedidos-preview-es-dark.png";
import PedidosEn from "../../assets/beartrack/pedidos-preview-en.png";
import PedidosEnDark from "../../assets/beartrack/pedidos-preview-en-dark.png";
import PedidosZh from "../../assets/beartrack/pedidos-preview-zh.png";
import PedidosZhDark from "../../assets/beartrack/pedidos-preview-zh-dark.png";
import PedidosPt from "../../assets/beartrack/pedidos-preview-pt.png";
import PedidosPtDark from "../../assets/beartrack/pedidos-preview-pt-dark.png";

const PREVIEW_BY_LANG = {
  es: { light: PedidosEs, dark: PedidosEsDark },
  en: { light: PedidosEn, dark: PedidosEnDark },
  zh: { light: PedidosZh, dark: PedidosZhDark },
  pt: { light: PedidosPt, dark: PedidosPtDark },
};

/**
 * Panel lateral del login (split-screen tipo Whaticket): gradiente de marca +
 * titular + una captura real del menú de Pedidos (datos anonimizados) dentro de
 * un marco de navegador. Decorativo (aria-hidden); se oculta en pantallas chicas.
 * En modo oscuro usa una superficie oscura con dejo de marca y una captura dark
 * (marco + screenshot) para que no se vea "claro" junto al formulario.
 */
const LoginAside = () => {
  const { t, i18n } = useTranslation();
  const { isDark } = useTheme();
  // Normaliza p. ej. "es-CL" → "es"; cae a español si el idioma no tiene captura.
  const langKey = (i18n.language || "es").slice(0, 2).toLowerCase();
  const preview = PREVIEW_BY_LANG[langKey] || PREVIEW_BY_LANG.es;
  const shot = isDark ? preview.dark : preview.light;
  return (
    <aside className="login-aside">
      <div className="login-aside__glow" aria-hidden="true" />
      <div className="login-aside__content">
        <div className="login-aside__brand">
          <img src={BeartrackLogo} alt="Beartrack" className="login-aside__logo" />
        </div>

        <div className="login-aside__copy">
          <h2 className="login-aside__title">
            {t("Toda tu operación de última milla, en un solo lugar.")}
          </h2>
          <p className="login-aside__text">
            {t("Pedidos, retiros, rutas en vivo y facturación. Controla cada entrega de punta a punta.")}
          </p>
        </div>

        <div className="login-preview" aria-hidden="true">
          <div className="login-preview__bar">
            <span className="login-preview__dot login-preview__dot--r" />
            <span className="login-preview__dot login-preview__dot--y" />
            <span className="login-preview__dot login-preview__dot--g" />
            <div className="login-preview__url">qa2-portal.beartrackapp.com/pedidos</div>
          </div>
          <img
            src={shot}
            alt={t("Panel de Pedidos de Beartrack")}
            className="login-preview__shot"
          />
        </div>
      </div>
    </aside>
  );
};

export default LoginAside;
